import React from 'react';
import classNames from 'classnames';
import { QuestionTypeViewPropTypes } from '../../utils';
import { InputNumber } from '../../../neuro-ui';
import { useNeuroMessages } from '../MessageContext';

const Number = (props) => {
  const { className, valueChanged, question, value: { value } = {}, ...rest } = props;
  const hasValue = value !== undefined;

  const messageContext = useNeuroMessages();
  const classes = classNames(className, {
    'number-format': true,
  });

  return (
    <div className={classes}>
      <InputNumber
        onChange={valueChanged}
        plus={<i className="fa fa-plus" />}
        minus={<i className="fa fa-minus" />}
        step={question?.attributes?.step || 1}
        value={value}
        min={question?.attributes?.min || 0}
        max={question?.attributes?.max || 10000000}
        format={question?.attributes?.format || 'number'}
        pad={
          <span>
            <i className="fa fa-calculator" />
          </span>
        }
        padElementId="root"
        header={messageContext.formatIntlMessage({ id: question.appkey })}
        placeholder={messageContext.getMessage(
          `${question.appkey}.input.placeholder`
        )}
        decimalScale={question?.attributes?.decimalScale || 0}
        className={hasValue ? 'numberFormatComponent--hasValue' : null}
        { ...rest }
      />
    </div>
  );
};

Number.propTypes = QuestionTypeViewPropTypes;

export default Number;
